module.exports = __webpack_public_path__ + "img/bg-service-item.7231020e.png";